import { FETCH_PLAN_CANCELLATION_FEE, FETCH_PLAN_CANCELLATION_FEE_DONE, FETCH_PLAN_CANCELLATION_FEE_ERR } from './actionTypes';
export const fetchPlanCancellationFee = () => ({
    type: FETCH_PLAN_CANCELLATION_FEE
});
export const doneFetchingPlanCancellationFee = (data) => ({
    type: FETCH_PLAN_CANCELLATION_FEE_DONE,
    data
});
export const errorFetchingPlanCancellationFee = (data) => ({
    type: FETCH_PLAN_CANCELLATION_FEE_ERR,
    errorMessage: data
});
//# sourceMappingURL=actionCreators.js.map